import { render, staticRenderFns } from "./addStock.vue?vue&type=template&id=8c16bc80&scoped=true&"
import script from "./addStock.vue?vue&type=script&lang=js&"
export * from "./addStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c16bc80",
  null
  
)

export default component.exports